import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";

export const BASE_API_PATH = "/api/currencies";
export const ADMIN_API_PATH = "/api/admin/currencies";

export const fetchCurrencies = createAsyncThunk("currency/fetch", async () => {
  const { data } = await localhost.get(BASE_API_PATH);
  return data;
});

export const updateCurrencySettings = createAsyncThunk(
  "currency/updateSettings",
  async (
    { defaultCurrencyCode = null, rates = [], removals = [] },
    { rejectWithValue }
  ) => {
    try {
      const rsp = await localhost.put(ADMIN_API_PATH, {
        defaultCurrencyCode,
        rates,
        removals,
      });
      return rsp?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data ?? null);
    }
  }
);
